import type { NavigateFunction } from 'react-router-dom'
import type { NavigablePaletteRow } from './paletteRow'

/**
 * Where Enter takes each kind of row. Contacts go to the Contacts page with the drawer
 * param set, the existing cross-page link form.
 */
export function paletteRowHref(row: NavigablePaletteRow): string {
  switch (row.kind) {
    case `contact`:
      return `/contacts?tab=all&drawer=${row.id}`
    case `activity`:
      return `/activities?drawer=${row.id}`
    case `thread`:
      // The Inbox selects a conversation from `tab` and scopes its list by `locationId`.
      return `/inbox?locationId=${row.thread.message.locationId}&tab=${row.id}`
    case `see-all-activities`:
      return `/activities?query=${encodeURIComponent(row.query)}`
    case `page`:
      return row.page.href
  }
}

export function openPaletteRow(navigate: NavigateFunction, row: NavigablePaletteRow): void {
  navigate(paletteRowHref(row))
}
